import { makeStyles, Button } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "80%",
    margin: "0 auto",
    textAlign: "left",
    backgroundColor: "white",
  },
  heading: {
    fontWeight: 500,
  },
  btnsBox: {
    margin: "10px 0 0 0",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "200px",
    margin: "10px",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "2px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
}));

function RegistrationBox() {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <h2 className={classes.heading}>Don't have an Account?</h2>
      <p>
        Sign up for a free account at our store. Registration is quick and easy.
        It allows you to be able to order from our shop. To start shopping click
        register.
      </p>
      <div className={classes.btnsBox}>
        <Link
          style={{ textDecoration: "none", margin: "10px" }}
          to="/register/customer"
        >
          <Button className={classes.btn}>Register as Customer</Button>
        </Link>
        <Link
          style={{ textDecoration: "none", margin: "10px" }}
          to="/register/author"
        >
          <Button className={classes.btn}>Register as Author</Button>
        </Link>
        <a
          style={{ textDecoration: "none", margin: "10px" }}
          target="blank"
          href="http://eksplode.web.s3-website-us-east-1.amazonaws.com/"
        >
          <Button className={classes.btn}>Register as eksplode! Member</Button>
        </a>
      </div>
    </div>
  );
}

export default RegistrationBox;
